import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: 'row',
    // marginTop: 10,
    marginBottom: 12,
    padding: 8,
    // backgroundColor: '#F3F3F3',
    // borderTopWidth: 1,
    // borderColor: '#ccc',
  },
  reportTitle: {
    fontSize: 9,
    lineHeight: 1.6,
    color: '#000',
  },
});

const InvoiceThankYouMsg = () => (
  <View style={styles.titleContainer}>
    <Text style={styles.reportTitle}>
      The booking is powered by Holidays Seychelles{'\n'}
      Emergency number - +248 437 6666{'\n'}
      Thanks for booking with us!
    </Text>
  </View>
);

export default InvoiceThankYouMsg;
